import { render, staticRenderFns } from "./addCapacityChartModal.vue?vue&type=template&id=2a70b679&"
import script from "./addCapacityChartModal.vue?vue&type=script&lang=js&"
export * from "./addCapacityChartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports